<cx-floating-button [icon]="icon" (isMenuActiveChange)="onClick()"></cx-floating-button>
